module.exports = __webpack_public_path__ + "img/uni-hamburg-logo.eb68eb0e.svg";